/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
//TODO import the tech images;
//TODO change the tehc finish the last part
// reactstrap components
import { Button, Container, Row, Col, UncontrolledTooltip } from "reactstrap";

class Download extends React.Component {
  render() {
    return (
      <>
        <section className="section section-lg">
          <Container>
            <Row className="row-grid justify-content-center">
              
              <Col className="text-center" lg="8">
               
                <div className="text-center">
                  <h4 className="display-4 mb-5 mt-5">
                  Languages and Tools:
                  </h4>
                  <Row className="justify-content-center">
                  <Col lg="2" xs="4">
                      <a
                        href="https://en.wikipedia.org/wiki/HTML#:~:text=The%20HyperText%20Markup%20Language%2C%20or,scripting%20languages%20such%20as%20JavaScript."
                        id="tooltip308866162"
                        target="_blank"
                      >
                        <img
                          width = "50"
                          style= {{marginTop:20}}
                          alt="..."
                          className="img-fluid"
                          src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_640.png"

                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip308866162">
                        HTML - The HyperText Markup Language
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://en.wikipedia.org/wiki/CSS"
                        id="tooltip308866164"
                        target="_blank"
                      >
                        <img
                          width = "50"
                          style= {{marginTop:20}}
                          alt="..."
                          className="img-fluid"
                          src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747_1280.png"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip308866164">
                      Cascading Style Sheets - is a style sheet language 
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://www.javascript.com"
                        id="tooltip308866165"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                          
                          style= {{marginTop:22}}
                          src="https://www.freepnglogos.com/uploads/javascript-png/javascript-logo-transparent-logo-javascript-images-3.png"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip308866165">
                      JavaScript- is a lightweight, interpreted lab programming language
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://getbootstrap.com"
                        id="tooltip255035741"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                          src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/bootstrap.jpg"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip255035741">
                        Bootstrap 4 - Most popular front-end component library
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://reactjs.org"
                        id="tooltip308866163"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                          src="https://s3.amazonaws.com/creativetim_bucket/tim_static_images/presentation-page/react.jpg"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip308866163">
                        React - A JavaScript library for building user
                        interfaces
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://nodejs.org/en/"
                        id="tooltip265846621"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                         
                          src="https://logosvector.net/wp-content/uploads/2015/09/nodejs-logo.png"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip265846621">
                      Node.js -brings event-driven programming to web servers
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://expressjs.com"
                        id="tooltip233150499"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          width = "100"
                          style= {{marginTop:40}}
                          className="img-fluid"
                          src="https://upload.wikimedia.org/wikipedia/commons/6/64/Expressjs.png"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip2331504999">
                      Most popular database for modern apps
                      </UncontrolledTooltip>
                    </Col>
                    
                    <Col lg="2" xs="4">
                      <a
                        href="https://www.mongodb.com "
                        id="tooltip2331504999"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          width = "80"
                          style= {{marginTop:10}}
                          className="img-fluid"
                          src="https://infinapps.com/wp-content/uploads/2018/10/mongodb-logo.png"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip233150499">
                      framework that provides a robust set of features for web and mobile applications.
                      </UncontrolledTooltip>
                    </Col>
                    
                    <Col lg="2" xs="4">
                      <a
                        href="https://code.visualstudio.com"
                        id="tooltip76119384"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                          width = "50"
                          style= {{marginTop:20}}
                          src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/1024px-Visual_Studio_Code_1.35_icon.svg.png"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip761193843">
                      Git is a free and open source distributed version control system
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://git-scm.com"
                        id="tooltip761193843"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                          width = "50"
                          style= {{marginTop:20}}
                          src="https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip76119384">
                      Visual Studio Code - is a code editor 
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://www.mysql.com"
                        id="tooltip646643508"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                          width = "50"
                          style= {{marginTop:20}}
                          src="https://1000logos.net/wp-content/uploads/2020/08/MySQL-Logo.png"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip64664350833">
                      PyCharm -has tons of advantages when compared to text editors
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://www.jetbrains.com/pycharm/ "
                        id="tooltip64664350833"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                          width = "50"
                          style= {{marginTop:20}}
                          src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/PyCharm_Icon.svg/1200px-PyCharm_Icon.svg.png"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip646643508">
                      Database Service is a fully managed database service to deploy cloud-native applications
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://sass-lang.com "
                        id="tooltip6466435082"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                          width = "70"
                          style= {{marginTop:20}}
                          src="https://miro.medium.com/max/512/1*9U1toerFxB8aiFRreLxEUQ.png"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip6466435082">
                      Sass is the most mature, stable, and powerful professional grade CSS extension language in the world
                      </UncontrolledTooltip>
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="http://es6-features.org"
                        id="tooltip64664350824"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                          width = "60"
                          style= {{marginTop:20}}
                          src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/512px-Typescript_logo_2020.svg.png"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip646643508245">
                      was the second major revision to JavaScript. ECMAScript 2015 is also known as ES6
                      </UncontrolledTooltip>  
                    </Col>
                    <Col lg="2" xs="4">
                      <a
                        href="https://www.typescriptlang.org"
                        id="tooltip646643508245"
                        target="_blank"
                      >
                        <img
                          alt="..."
                          className="img-fluid"
                          width = "70"
                          style= {{marginTop:20}}
                          src="https://i0.wp.com/youvcode.com/wp-content/uploads/2018/06/es6.png?fit=375%2C375&ssl=1"
                        />
                      </a>
                      <UncontrolledTooltip delay={0} target="tooltip64664350824">
                      TypeScript is a strongly typed programming language which builds on JavaScript giving you better tooling at any scale.
                      </UncontrolledTooltip>  
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }
}

export default Download;
